import { render } from "./MediaPreview.vue?vue&type=template&id=aee5dc76&scoped=true"
import script from "./MediaPreview.vue?vue&type=script&lang=js"
export * from "./MediaPreview.vue?vue&type=script&lang=js"

import "./MediaPreview.vue?vue&type=style&index=0&id=aee5dc76&scoped=true&lang=css"

import exportComponent from "/opt/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aee5dc76"]])

export default __exports__